$(() => {

	// Prevent closing from click inside dropdown
	$(document).on("click", ".dropdown-menu", function(e) {
		e.stopPropagation();
	});

	function extraUrlCondition() {
		const disableLink = $('#primary-menu .menu-item a[href*="#"]');
		const disabledForClick = disableLink.closest("li");

		disabledForClick.addClass("disabled");

		$(".menu-item-has-children > a").on("click", function(event) {
			if ($(this).attr("href") !== "#") {
				event.preventDefault();
				window.location.href = $(this).attr("href");
			} else {
				event.preventDefault();
			}
		});

		$(".menu-item-has-children").each(function() {
			$(this).append('<span class="el-for-click"></span>');
		});
		const elForClick = $(".el-for-click");

		$(elForClick).on("click", function(event) {
			event.preventDefault();

			$(this).toggleClass("active");
			$(this).closest(".menu-item-has-children").toggleClass("collapsed");
			$(this)
				.siblings(".dropdown-menu")
				.toggleClass("show");
		});
	}

	extraUrlCondition();

  const mobileHeaderTop = $('.mobile-nav-modal__top');
  const mobileHeaderBottom = $('.mobile-nav-modal__bottom');
  const mobileNavWrapper = $('.mobile-nav-modal__wrapper');

  function setMobileNavHeight() {
    if ( mobileNavWrapper.length && mobileHeaderTop.length && mobileHeaderBottom.length ) {
      const height = window.innerHeight - (mobileHeaderTop.outerHeight() + mobileHeaderBottom.outerHeight()) + 'px';
      mobileNavWrapper.css({minHeight: height });
    }
  }
  setMobileNavHeight();


	$(window).resize(function() {
		const win = $(this);
		if (win.width() >= 992) {
			$("#primaryNavBar").removeClass("show");
			$(".navbar-nav")
				.find(".menu-item.show")
				.removeClass("show");
			$(".dropdown-menu")
				.removeClass("show")
				.removeAttr("style");
			$(".el-for-click").removeClass("active");
			$("html").css({
				marginTop: 0,
				overflow: "visible",
				left: "auto",
				right: "auto",
				top: "auto",
				bottom: "auto",
				position: "static",
			});
		}
    setMobileNavHeight();
	});

  $(document).on('touchstart', function(){
    $(this).trigger('hover');
  })

	const navbarMobile = $(".navbar--mobile");
	const headerMainMobile = $(".header-main--mobile");
	const quickLinksMobile = $(".mobile-nav-modal__featured-list");

  function navToggleHandler(){
    headerMainMobile.toggleClass("visible");

    if (headerMainMobile.hasClass('visible')) {
      $('body').css("overflow", "hidden");
    }
    else {
      $('body').css("overflow", "auto");
      
      //Menu refreshing after closing
      $(".menu-item-has-children.collapsed").each(function() {
        $(this).removeClass('collapsed');
      });
      $(".menu-item-has-children .dropdown-menu.show").each(function() {
        $(this).removeClass('show');
      });
    }
  }
  
  $(".mobile-nav-modal a[href^='#'] ").on("click", navToggleHandler);
	$(".navbar-toggler").on("click", navToggleHandler);

	$(".mobile-nav-modal__featured-title").on("click", function() {
		$(this).toggleClass("active");
		navbarMobile.toggleClass("active");
		quickLinksMobile.toggleClass("active");
	});
});



// WEBPACK FOOTER //
// ./scripts/modules/_navbar.js